var localStorageManager = {
  //local storage key for tokens
  storekeyTnx: 'tnxStore',

  //age at which we remove items in minutes
  storeTnxAge: 1440, // 1 Day

  getStore: function (storekey) {
    return window.localStorage.getItem(storekey)
  },
  setStore: function (storekey, storeObject) {
    window.localStorage.setItem(storekey, JSON.stringify(storeObject))
  },

  getTokenStore: function () {
    var store = localStorageManager.getStore(localStorageManager.storekeyTnx)
    if (store == null) {
      var object = { items: [] }
      store = JSON.stringify(object)
      localStorageManager.setStore(localStorageManager.storekeyTnx, object)
    }
    var storeObject = JSON.parse(store)
    var purgedStoreObject = localStorageManager.purgeTokens(storeObject)
    return purgedStoreObject
  },

  removeTokenStore: function () {
    window.localStorage.removeItem(localStorageManager.storekeyTnx)
  },

  getToken: function (tnxId) {
    var store = localStorageManager.getTokenStore()
    //check the length before tring find
    var storeSize = store.items.length
    if (storeSize == 0) return null
    var item = store.items.find((item) => item.tnxId === tnxId)
    return item
  },

  addToken: function (tnxId, token) {
    //get the store
    var store = localStorageManager.getTokenStore()
    //set the date and time added
    let addedDate = new Date()
    //create the store item
    var item = { tnxId: tnxId, addedDate: addedDate, token: token }
    //push the item into the store
    store.items.push(item)
    localStorageManager.setStore(localStorageManager.storekeyTnx, store)
  },

  purgeTokens: function (storeObject) {
    var now = new Date()
    for (var i = 0; i < storeObject.items.length; i++) {
      var item = storeObject.items[i]
      var diff = Math.abs(now - new Date(item.addedDate))
      var minutes = Math.floor(diff / 1000 / 60)
      if (minutes > localStorageManager.storeTnxAge) {
        storeObject.items.splice(i, 1)
        i-- // decrement index if item is removed
      }
    }
    return storeObject
  },
}

export default localStorageManager
